import React, {Suspense, useState, useEffect, useRef, useCallback,useSearchParams} from "react";
import '../Styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Profile from "./Profile";
import OtherPlayers from "./OtherPlayers";
import Battle from "./Battle";
import Reward from "./Reward";
import Win from "./Win";
import SessionStart from "./SessionStart";
import {useTranslation} from "react-i18next";
import System from "./System";
import {GearFill, People, PersonBadge, PlayCircle} from "react-bootstrap-icons";
import {Overlay} from "react-bootstrap";
import {Tooltip} from "react-bootstrap";
import MunchkinLoader from "./MunchkinLoader";

export const GameContext = React.createContext({
    "send_to_socket": () => {},
    "update_player_level": () => {},
    "changeView": () => {},
    "game": {
        "current_player_id":0,
        "current_gender":1,
        "session_id":0,
        "wins_player_id":0,
        "players":{
            0 : {
                "name": "",
                "gender": "",
                "level": "",
                "gear_power": "",
                "total_power": "",
                "is_changed_gender":"",
                "gears": [
                    {"slot": "", "power": "", "id": ""}
                ],
                "effects": [
                    {"mod": "", "battle_count": "1"}
                ]
            }
        },
        "current_battle": {
            "id":0,
            "is_started": false,
            "player": {
                "id": "",
                "gender": "",
                "mod": "",
                "total_power": ""
            },
            "mobs": [
                {"level": "", "mod": "", "id":""}
            ],
            "ally": {
                "id": null,
                "mod": null,
                "total_power": null
            },
            "party_power": "",
            "mobs_power": "",
            "is_player_wins": ""
        }
    }


});
function App() {
    const { t } = useTranslation();

    let search = window.location.search;
    let params = new URLSearchParams(search);
    if(params.get('player_id') != null){
        localStorage.setItem('player_id',params.get('player_id'));
    }
    if(params.get('session_id') != null){
        localStorage.setItem('session_id',params.get('session_id'));
    }

    const [player_id,setPlayerId] = useState(localStorage.getItem('player_id') || 0);
    const [session_id,setSessionId] = useState(localStorage.getItem('session_id')|| 0);
    const [view,setView] = useState('profile');

    const [show_profile,setShowProfile] = useState(true);
    const [show_players,setShowPlayers] = useState(false);
    const [show_system,setShowSystem] = useState(false);
    const [show_battle,setShowBattle] = useState(false);

    const [is_loaded,setIsLoaded] = useState(false);

    const [ws_status, setWSStatus] = useState("");
    const ws = useRef(null);

    const sendToSocket = (data) => {
        if (!ws.current) return;
        setIsLoaded(false);
        console.log('SEND TO SOCKET');
        console.log(data);
        ws.current.send(JSON.stringify(data));
    };

    function updateLevel(player, level) {
        if(player !== undefined) {
            let sessionStartObject = {
                "method": "updateLevel",
                "data": {
                    "player_id": player.id,
                    "level": level
                }
            };
            sendToSocket(sessionStartObject);
        }
    }

    const changeView = (view) => {
        setView(view);
    }

    const [game_context, setGameContext] = useState({
        "send_to_socket":sendToSocket,
        "update_player_level": updateLevel,
        "changeView": changeView,
        "game": localStorage.getItem('game') ? JSON.parse(localStorage.getItem('game')) : {
            "current_battle": {
                "id":0,
                "is_started": false
            }
        }

    });



    useEffect(() => {

        if(player_id === 0 && session_id === 0) {
            ws.current = new WebSocket(process.env.REACT_APP_WS_URL); // создаем ws соединение
            setIsLoaded(true);
        } else {
            let url = process.env.REACT_APP_WS_URL+"?session_id="+session_id+"&player_id="+player_id;
            ws.current = new WebSocket(url); // создаем ws соединение
        }

        ws.current.onopen = () => setWSStatus("Соединение открыто");	// callback на ивент открытия соединения
        ws.current.onclose = () => setWSStatus("Соединение закрыто"); // callback на ивент закрытия соединения

        gettingData();

        return () => ws.current.close(); // кода меняется isPaused - соединение закрывается*/
    },[]);

    const gettingData = useCallback(() => {
        if (!ws.current) return;

        ws.current.onmessage = e => {                //подписка на получение данных по вебсокету
            console.log('RECEIVING DATA ==================================================================================');
            console.log(game_context);
            const data = JSON.parse(e.data);
            let new_game_context = Object.assign({}, game_context);
            console.log(data);
            if(player_id === 0 && session_id === 0) {
                localStorage.setItem('player_id',data.current_player_id);
                setPlayerId(data.current_player_id);
                localStorage.setItem('session_id',data.session_id);
                setSessionId(data.session_id);
            }
            localStorage.setItem('game',JSON.stringify(data));
            new_game_context.game = data;
            setGameContext(new_game_context);

            if(data.wins_player_id > 0) {
                setView('win');
            }
            console.log(data.current_battle.is_started);
            console.log(data.current_battle.player.id);
            console.log(data.current_player_id);

            if(data.current_battle.is_started === true && data.current_battle.player.id === data.current_player_id) {
                setView('battle');
            }


            console.log('RECEIVING DATA  END ==================================================================================');
            setIsLoaded(true);
        };
    }, []);

    const target = useRef(null);

    function renderViewSwitch() {
        switch (view){
            case 'profile':
                return <Profile current_player={game_context.game.players[player_id]}/>;
                break;
            case 'players':
                return <OtherPlayers players={game_context.game.players}/>;
                break;
            case 'system':
                return <System />;
                break;
            case 'battle':
                return <Battle current_battle={game_context.game.current_battle}/>;
                break;
            case 'reward':
                return <Reward player={game_context.game.players[player_id]}/>;
                break;
            case 'win':
                return <Win player={game_context.game.players[game_context.game.wins_player_id]}/>;
                break;
            default:
                return <div></div>;
                break;
        }
    }

    return (
        <div>
            <GameContext.Provider value={game_context}>
                {player_id == 0 &&
                <div className="app">
                    <Suspense fallback={<div></div>}>
                        <SessionStart />
                    </Suspense>
                </div>
                }
                {is_loaded === false && <MunchkinLoader />}

                {player_id !== 0 && game_context.game.players !==undefined &&
                    <div className="app">
                        {renderViewSwitch()}
                    </div>
                }
            </GameContext.Provider>
            <footer className={game_context.game.current_gender && game_context.game.current_gender===2 ? 'btn-pink' : ''}>
                <div className="row">
                    <div className="col-3 side-line" onClick={() => changeView('profile')}>
                        <PersonBadge />
                        <br />
                        {t('profile')}
                    </div>
                    <div className="col-3 side-line" onClick={() => changeView('players')}>
                        <People />
                        <br />
                        {t('players')}
                    </div>
                    <div className="col-3 side-line" onClick={() => changeView('system')}>
                        <GearFill />
                        <br />
                        {t('system')}
                    </div>
                    <div className="col-3" onClick={() => game_context.game.current_battle.is_started === true ? changeView('battle') : ''} ref={target} >
                        <Overlay show={(game_context.game.current_battle.is_started && view !== 'battle')} placement="top" target={target.current}>
                            {(props) => (
                                <Tooltip id="overlay-example" {...props}>
                                    {t('battle_already_started')}
                                </Tooltip>
                            )}
                        </Overlay>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="32px" width="32px">
                                <path d="M0 0h512v512H0z" fill="#fff" fillOpacity="0" />
                                <g transform="translate(0,0)">
                                    <path
                                        d="M478.89 21.842c-6.434-.113-15.047 3.628-24.242 12.822L328.912 160.4c0-.007.003-.015.004-.023l-60.228 60.228.01.01-12.727 12.727-.01-.01-22.657 22.658.01.01-12.44 12.44-.01-.01-30.884 30.884c0 .005.002.01.004.014l-55.656 55.656 22.627 22.627 320.32-320.32c18.827-18.825 14.79-35.217 1.616-35.448zm-445.84.06c-13.176.232-17.213 16.623 1.614 35.45l185.912 185.912 22.658-22.66-44.164-44.16c0 .02 0 .038-.002.058L57.29 34.725C48.098 25.53 39.484 21.79 33.05 21.902zm234.538 36.39c-9.308 42.14-12.624 79.314-27.922 121.454-21.636-16.89-30.623-41.47-43.836-63.414.586 10.88 1.66 22.256 2.42 33.838l57.71 57.71 78.485-78.485a2474.362 2474.362 0 0 1 4.078-21.237c-21.27 28.796-42.452 44.68-71.396 73.475-6.752-45.418.278-77.923.46-123.34zM87.873 170.623c-.052.003-.08.017-.082.044-.258 5.25 104.427 78.357 96.222 83.578-13.465 8.55-57.975 31.11-83.508 44.914 19.72-3.345 53.538-7.933 72.18-8.002l35.453-35.453-63.655-63.652c-27.027-10.216-54.915-21.568-56.61-21.43zm245.143 56.144l-29.086 29.086 56.174 56.17c10.848.735 21.692 1.416 32.5 1.218-24.518-15.9-71.99-43.734-71.64-50.568.353-6.887 63.447-21.216 95.518-31.606-27.787-2.137-55.973 3.846-83.466-4.3zm-41.813 41.812l-22.656 22.656 86.437 86.438 22.627-22.627-44.473-44.475h.06l-41.994-41.992zm-35.098 35.098l-57.703 57.703c.408 14.207.21 28.454-.52 40.38 11.322-26.84 17.846-51.86 45.827-74.473 14.444 11.985 24.816 40.267 37.224 60.4-.91-19.042-6.873-52.002-5.03-64.214l-19.8-19.797zM111.7 354.984L98.974 367.71l45.256 45.257 12.725-12.73-45.252-45.253h-.002zm288.538.06l-45.254 45.253v.002l12.727 12.727 45.257-45.256-12.73-12.725zM94.023 385.39l-9.9 9.9 32.527 32.526 9.9-9.9-32.527-32.527zm323.893.06l-32.527 32.527 9.9 9.9 32.526-32.527-9.9-9.9zm-346.52 22.568L21.9 457.512l32.528 32.527 10.603-10.604 10.73 10.726 17.847-17.848-10.728-10.726 21.042-21.043-9.9-9.9-38.89 38.89-12.728-12.728 38.89-38.89-9.9-9.9zm369.15.06l-9.9 9.9 38.89 38.89-12.73 12.728-38.89-38.89-9.898 9.9 49.494 49.494 32.527-32.528-10.604-10.603 10.726-10.73-17.848-17.847-10.726 10.728-21.043-21.042z"
                                        fill="#000" fillOpacity="1"  />
                                </g>
                            </svg>
                            <br />
                            {t('battle')}
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default App;
